'use strict';

const SELECTORS = {
    fieldHolder: '.field',
};

export function init() {
    document.addEventListener('focusin', function(ev) {
        const holder = ev.target.closest(SELECTORS.fieldHolder);

        if (holder) {
            holder.classList.add('focus');
        }
    });

    document.addEventListener('focusout', function(ev) {
        const el = ev.target;
        const holder = el.closest(SELECTORS.fieldHolder);

        if (holder && el.value == '') {
            holder.classList.remove('focus');
        }
    });

    /**
     * Below code is used to prevent form submission if the Recaptcha is not checked
     * Adds a callback for both submit and when the captcha expires
     */
    document.querySelectorAll('.g-recaptcha').forEach(el => {
        const form = el.closest('form');
        const preventFormSubmissionFn = function (ev) {
            ev.preventDefault();
            return false;
        }
        form.addEventListener('submit', preventFormSubmissionFn);

        window[el.getAttribute('data-callback')] = () => {
            form.removeEventListener('submit', preventFormSubmissionFn);
            console.info('g-recaptcha: Prevent form submission removed');
        }
        window[el.getAttribute('data-expired-callback')] = () => {
            form.addEventListener('submit', preventFormSubmissionFn);
            console.info('g-recaptcha: Prevent form submission re-applied');
        }

    });
}

export default { init }
